export default __webpack_public_path__ + "static/media/Manrope-Bold.d109d6f8.ttf";